/* eslint-disable import/prefer-default-export */
export { default as Tooltip } from './Tooltip';
